<div class="key-info-details">
    <div class="main-info">
        <div class="section-title">Nøkkelinfo</div>
        <key-value-pair-list [keyValuePairs]="mainInfo()"></key-value-pair-list>
    </div>
    <div class="areal-info">
        <div class="section-title">Arealinformasjon</div>
        <key-value-pair-list [title]="'Arealinformasjon'" [keyValuePairs]="areasInfo()"></key-value-pair-list>
    </div>
    <div class="neighbourhood-info">
        <div class="section-title">Nabolagsprofil</div>
        <a href="https://nabolag.no/store" target="_blank" style="cursor: pointer">
            <div><span>Bestill PDF</span></div>
        </a>
        <key-value-pair-list [title]="'Nabolagsinformasjon'"
            [keyValuePairs]="neighbourhoodInfo()"></key-value-pair-list>
    </div>
    <div class="features-info">
        <div class="section-title">Egenskaper</div>
        <key-value-pair-list [title]="'Egenskaper'" [keyValuePairs]="featuresInfo()"></key-value-pair-list>
    </div>
</div>